export default {"src":"/_next/static/media/up.49c46f11.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};